module.exports = __webpack_public_path__ + "media/21.fa0949fd.mp3";